import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
// 引入语言资源文件
import en from '@/lang/en.js';
import zh from '@/lang/zh.js';
Vue.use(VueI18n);
const lang = localStorage.getItem('lang') || 'zh'
// 创建 VueI18n 实例
const i18n = new VueI18n({
  locale: lang, // 默认语言为中文
  messages: {
    en: en,
    zh: zh
  }
});

export default i18n